<template>
 <div id="app">
  <div class="left">
      <el-menu
      default-active="0-0"
      class="el-menu-vertical-demo main menu"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b">
      <div class="system">报餐管理系统</div>
      <el-submenu v-for="item,index in list" :key="index" data-index="index" :index="index+''">
        <template slot="title">
          <i class="el-icon-s-platform"></i>
          <span>{{ item.parent }}</span>
        </template>
        <el-menu-item-group v-for="_item,_index in item.child" :key="_index">
          <router-link class="router-link-active" :to="{name:_item.name}">
             <el-menu-item :index="index+'-'+_index" >
               <i class="el-icon-s-tools"></i>
               {{ _item.title }}</el-menu-item>
             </router-link>
        </el-menu-item-group>
 
      </el-submenu>
      <!-- <el-menu-item index="2">
        <i class="el-icon-menu"></i>
        <span slot="title">导航二</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="3" disabled>
        <i class="el-icon-document"></i>
        <span slot="title">导航三</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="4">
        <i class="el-icon-setting"></i>
        <span slot="title">导航四</span>
      </el-menu-item> -->
    </el-menu>
    </div>

    <div class="content">
       <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  data () {
    return {
          // 帮助端
     list:[
        {parent:'公司管理',child:[
        {title:'公司信息',name:'infoManage'},
      ]},
      {parent:'菜谱管理',child:[
        {title:'菜谱管理',name:'menus'},
      ]},
      {parent:'报餐管理',child:[
        {title:'报餐明细',name:'mealOrderDetail'},
        {title:'报餐统计',name:'menuOrders'},
      ]},
      {parent:'用户管理',child:[
        {title:'用户列表',name:'UserManage'},
      ]},
      // {parent:'待定',child:[
      //   {title:'报名详情',name:'EnrollDetail'},
      // ]},
    ],
     }
  },
}
</script>

<style>
html{
  height: 100%;
}
body{
    padding: 0;
  margin: 0;
  height: 100%;
}
.left{
  width: 200px;
  height: 100%;
}
body{
  height: 100%;
}
.system{
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  padding: 10px;
}
#app {
  padding: 0;
  margin: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  display: flex;
  /* margin-top: 60px; */
}
.menu{
  position: absolute;
  top:0;
  left: 0;
  height: 100%;
  width: 200px;
  background-color: red;
}
.content{
  /* margin-left: 200px; */
  flex: 1;
  padding: 20px;
  height: 100%;
  overflow: scroll;
}
a {
    text-decoration:none ;
    /* color: #00ecfc; */
}
.router-link-active {
    /* text-decoraction: none ; */
    /* color: #00ecfc; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue